import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'

import { ContactForm } from '@/features/directory/components/contact-form'
import { useContact } from '@/features/directory/queries'
import { useUpdateContact } from '@/features/directory/mutations'
import type { PickedLocation } from '@/features/directory/schema'

function toBirthLocation(
  birthPlace: {
    city: string
    countryCode: string
    latitude: number
    longitude: number
  } | null,
): PickedLocation | null {
  if (!birthPlace) return null
  return {
    label: birthPlace.city,
    lat: birthPlace.latitude,
    lng: birthPlace.longitude,
    countryCode: birthPlace.countryCode,
  }
}

export const Route = createFileRoute('/_authed/directory/$id/edit')({
  component: () => {
    const { id } = useParams({ from: '/_authed/directory/$id/edit' })
    const navigate = useNavigate()
    const { data: contact, isLoading } = useContact(id)
    const updateContact = useUpdateContact()
    if (isLoading || !contact) return null
    return (
      <ContactForm
        initial={{
          firstName: contact.firstName,
          lastName: contact.lastName,
          birthDate: contact.birthDate,
          birthTime: contact.birthTime,
          birthLocation: toBirthLocation(contact.birthPlace),
          timezone: contact.timezone,
          relation: contact.relation,
        }}
        submitting={updateContact.isPending}
        onSubmit={async (patch) => {
          await updateContact.mutateAsync({ id, patch })
          void navigate({ to: '/directory/$id', params: { id } })
        }}
      />
    )
  },
})
